<template>
  <div>
    <b-modal id="personalized-quote-modal" :size="currentStep ===0 ? 'lg': 'xl'" centered>
      <b-button variant="close-btn" @click="closePersonalizedModal" class='btn-container' @hide="closePersonalizedModal">
        <i class="fas fa-times"></i>
      </b-button>
      <BasicDetails v-if="currentStep === 0"/>
      <PlanSelection :modal-heading="planSelectionHeading" v-if="currentStep === 1" quote-type="individual"/>
    </b-modal>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { checkValidZip, isOver18 } from "../../../../utils/validator";
import Api from "@/resource/Api";
import BasicDetails from "./BasicDetails.vue";
// import PlanDetails from "./PlanDetails.vue";
import PlanSelection from "../../../../components/PQS/PlanSelection.vue";

export default {
  name: "PersonalizedQuoteSubmission",
  validations: {
    firstName: {
      required
    },
    lastName: {
      required
    },
    dob: {
      required,
      isOver18
    },
    zip: {
      required,
      checkValidZip
    },
    tier: {
      required
    },
    gender: {
      required
    },
    email: {
      required,
      email
    },
    platform: {
      required
    },
    selectedCategoryOptions: {
      required
    },
    selectedPlanOptions: {
      required
    }
  },
  components:{
    PlanSelection,
    // PlanDetails,
    BasicDetails,
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      dob: '',
      zip: '',
      tier: '',
      salary: '',
      platform: '',
      platformName: '',
      email: '',
      gender: '',
      selectedPlanOptions: [],
      selectedPlanId: [],
      selectedCategoryOptions: [],
      selectedCategory: [],
      tierOptions: [
        { value: 'IO', text: 'Member Only' },
        { value: 'IS', text: 'Member + Spouse' },
        { value: 'IC', text: 'Member + Children' },
        { value: 'IF', text: 'Family' }
      ],
      genderOptions: [
        { value: 'M', text: 'Male' },
        { value: 'F', text: 'Female' }
      ],
      platformList: [],
      categoryList: [],
      planList: [],
      tempPlanList: [],
      renderPlanCategory: false,
      renderPlanList: false,

      planSelectionHeading: "Send Personalized Individual Quote"
    }
  },
  computed:{
    currentStep: function() {
      return this.$store.getters.currentQuoteStep;
    }
  },
  methods: {
    closePersonalizedModal() {
      this.$bvModal.hide('personalized-quote-modal')
      this.$store.commit('setCurrentIndividualQuoteStep', 0);
      this.$store.commit("setPlanData", []);
      this.$store.commit('setBasicIndividualDetails', {})
      this.$store.commit('setEnrollmentId', null);
    },
    onSelectPlan(selected) {
      if (selected.length > 0) this.selectedPlanId = selected.map(option => option.value);
      this.filterSelectablePlans(selected);
    },
    onSelectCategory(selected) {
      this.selectedCategory = selected.map(option => option.value);
      this.getPlanList()
    },
    clearSendQuoteInfo() {
      let app = this
      app.firstName = ''
      app.lastName = ''
      app.dob = ''
      app.tier = ''
      app.zip = ''
      app.salary = ''
      app.gender = ''
      app.email = ''
      app.portal = ''
      app.platform = null
      app.selectedPlanOptions = []
      app.selectedPlanId = []
      app.selectedCategoryOptions = [],
        app.selectedCategory = [],
        app.renderPlanCategory = false
      app.renderPlanList = false
      app.$v.$reset();
    },
    getPlatformInfo() {
      let app = this
      app.platformName = app.platform.text
      app.getCategoryList();
    },


    fetchEnrollmentPlatformList(){
      const url = "v2/quote/platform";
      let loader = this.$loading.show();
      Api.get(url).then(response => {
        const responseData = response.data.data;
        const platformList = responseData.map(item=>({
          text: item.platform_website,
          value: item.gid,
          platform_id: item.platform_id || item.id || null,
        }))
        this.$store.commit('setEnrollmentPlatformList', platformList);
      }).catch((e)=>{
        console.error(e);
      }).finally(()=>{
        loader.hide();
      })
    }
  },
  mounted(){
   this.fetchEnrollmentPlatformList();
   this.$store.commit('setBasicIndividualDetails', {});
   this.$store.commit('setCurrentIndividualQuoteStep', 0);
   this.$store.commit('setEnrollmentId', null);
   this.$store.commit('setPlanData', []);
  }
}
</script>

<style scoped></style><template>
  <div>
    <b-modal id="personalized-quote-modal" :size="currentStep ===0 ? 'lg': 'xl'" centered>
      <b-button variant="close-btn" @click="closePersonalizedModal" @hide="closePersonalizedModal">
        <i class="fas fa-times"></i>
      </b-button>
      <BasicDetails v-if="currentStep === 0"/>
      <PlanSelection :modal-heading="planSelectionHeading" v-if="currentStep === 1" quote-type="individual"/>
    </b-modal>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { checkValidZip, isOver18 } from "../../../../utils/validator";
import Api from "@/resource/Api";
import BasicDetails from "./BasicDetails.vue";
// import PlanDetails from "./PlanDetails.vue";
import PlanSelection from "../../../../components/PQS/PlanSelection.vue";

export default {
  name: "PersonalizedQuoteSubmission",
  validations: {
    firstName: {
      required
    },
    lastName: {
      required
    },
    dob: {
      required,
      isOver18
    },
    zip: {
      required,
      checkValidZip
    },
    tier: {
      required
    },
    gender: {
      required
    },
    email: {
      required,
      email
    },
    platform: {
      required
    },
    selectedCategoryOptions: {
      required
    },
    selectedPlanOptions: {
      required
    }
  },
  components:{
    PlanSelection,
    // PlanDetails,
    BasicDetails,
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      dob: '',
      zip: '',
      tier: '',
      salary: '',
      platform: '',
      platformName: '',
      email: '',
      gender: '',
      selectedPlanOptions: [],
      selectedPlanId: [],
      selectedCategoryOptions: [],
      selectedCategory: [],
      tierOptions: [
        { value: 'IO', text: 'Member Only' },
        { value: 'IS', text: 'Member + Spouse' },
        { value: 'IC', text: 'Member + Children' },
        { value: 'IF', text: 'Family' }
      ],
      genderOptions: [
        { value: 'M', text: 'Male' },
        { value: 'F', text: 'Female' }
      ],
      platformList: [],
      categoryList: [],
      planList: [],
      tempPlanList: [],
      renderPlanCategory: false,
      renderPlanList: false,

      planSelectionHeading: "Send Personalized Individual Quote"
    }
  },
  computed:{
    currentStep: function() {
      return this.$store.getters.currentQuoteStep;
    }
  },
  methods: {
    closePersonalizedModal() {
      this.$bvModal.hide('personalized-quote-modal')
      this.$store.commit('setCurrentIndividualQuoteStep', 0);
      this.$store.commit("setPlanData", []);
      this.$store.commit('setBasicIndividualDetails', {})
      this.$store.commit('setEnrollmentId', null);
    },
    onSelectPlan(selected) {
      if (selected.length > 0) this.selectedPlanId = selected.map(option => option.value);
      this.filterSelectablePlans(selected);
    },
    onSelectCategory(selected) {
      this.selectedCategory = selected.map(option => option.value);
      this.getPlanList()
    },
    clearSendQuoteInfo() {
      let app = this
      app.firstName = ''
      app.lastName = ''
      app.dob = ''
      app.tier = ''
      app.zip = ''
      app.salary = ''
      app.gender = ''
      app.email = ''
      app.portal = ''
      app.platform = null
      app.selectedPlanOptions = []
      app.selectedPlanId = []
      app.selectedCategoryOptions = [],
        app.selectedCategory = [],
        app.renderPlanCategory = false
      app.renderPlanList = false
      app.$v.$reset();
    },
    getPlatformInfo() {
      let app = this
      app.platformName = app.platform.text
      app.getCategoryList();
    },


    fetchEnrollmentPlatformList(){
      const url = "v2/quote/platform";
      let loader = this.$loading.show();
      Api.get(url).then(response => {
        const responseData = response.data.data;
        const platformList = responseData.map(item=>({
          text: item.platform_website,
          value: item.gid,
          platform_id: item.platform_id || item.id || null,
        }))
        this.$store.commit('setEnrollmentPlatformList', platformList);
      }).catch((e)=>{
        console.error(e);
      }).finally(()=>{
        loader.hide();
      })
    }
  },
  mounted(){
   this.fetchEnrollmentPlatformList();
   this.$store.commit('setBasicIndividualDetails', {});
   this.$store.commit('setCurrentIndividualQuoteStep', 0);
   this.$store.commit('setEnrollmentId', null);
   this.$store.commit('setPlanData', []);
  }
}
</script>

<style scoped>
#personalized-quote-modal .btn-container  {
  position: absolute;
  top: -14px !important;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
</style>